export default __webpack_public_path__ + "static/media/centroMoons-mobile@3x.8ae362c4.webp";